import React from 'react';

function CameraAppointmentDoneIcon() {
    return <svg
        className="camera-icon-appointment-ended"
        width="13px"
        height="13px"
        viewBox="0 0 13 13"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink">
        <title>9AB98DE8-6B40-4BEA-9D28-A028BBC531B3@1,5x</title>
        <g
            id="08---Consultas-Online"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd">
            <g
                id="MY-D-08-01-20"
                transform="translate(-972.000000, -602.000000)"
                fill="#000000">
                <g id="card2" transform="translate(382.000000, 569.000000)">
                    <g
                        id="cards/lista_médicos-copy-6"
                        transform="translate(0.000000, 30.000000)">
                        <g
                            id="Group"
                            transform="translate(589.000000, 2.000000)">
                            <g
                                id="ELEMENTS/ICONS/Camera/Standard"
                                transform="translate(1.640625, 1.875000)">
                                <path
                                    d="M10.7326608,0.147705406 C10.9587616,0.336661028 11.0001764,0.645102729 10.8458056,0.87719951 L10.7787174,0.960274653 L8.7275894,3.0749693 L8.72813353,3.12785557 L11.1119217,1.61971892 C11.5345472,1.35305531 11.8848913,1.5398416 11.9297255,2.03370098 L11.9345716,2.14417475 L11.9345716,8.0149489 C11.9345716,8.54949376 11.6113701,8.78969394 11.2010865,8.58705125 L11.1119217,8.53679549 L8.72813353,7.02865884 L8.72813353,7.51528079 C8.72813353,8.32904431 8.16400138,8.99779339 7.44267547,9.07365396 L7.30568409,9.08082056 L2.90740044,9.08081561 L1.08019849,10.966683 C0.851271486,11.2028776 0.459487254,11.2220249 0.205123916,11.0094498 C-0.0209768284,10.8204942 -0.0623916551,10.5120525 0.0919791692,10.2799557 L0.15906736,10.1968806 L9.85758626,0.190472208 C10.0865133,-0.04572232 10.4782975,-0.0648696697 10.7326608,0.147705406 Z M7.30568409,1.07569385 C7.4922109,1.07569385 7.67035229,1.11520764 7.83357486,1.1870446 L0.601974146,8.72650366 C0.319172172,8.47129536 0.127358141,8.09847193 0.0882241829,7.67593137 L0.0808263196,7.51528079 L0.0808263196,2.64123362 C0.0808263196,1.8274701 0.644958466,1.15872102 1.36628438,1.08286045 L1.50327576,1.07569385 L7.30568409,1.07569385 Z"
                                    id="Shape"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
}
export default CameraAppointmentDoneIcon;